<template>
  <div
    class="table__wrapper">
    <table>
      <thead>
      <tr>
        <th>Название профиля</th>
        <th>Тип плательщика</th>
        <th>Дата обновления</th>
        <th>Действия</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="profile of profileList"
        :key="profile.id"
        @dblclick="edit(profile.id)">
        <td>{{profile.name}}</td>
        <td>{{profile.profileType !== undefined ? profile.profileType.name : ''}}</td>
        <td>{{profile.updateDate}}</td>
        <td>
          <a
            class="link--success"
            title="Радактировать"
            @click="editProfile(profile.id)"
            href="#">Редактировать</a><br>
          <a
            v-if="profile.typeId !== companyTypeId"
            class="link--danger"
            title="Удалить"
            @click="removeProfile(profile.id)"
            href="#">Удалить</a><br>
        </td>
      </tr>
      </tbody>
    </table>
    <Btn
      @click="setCurrentStep({code: 'chooseType', payload: null})"
      title="Создать"></Btn>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import Btn from '../../form/Btn'

  export default {
    name: 'ProfileList',
    components: {
      Btn
    },
    data: function () {
      return {
        companyTypeId: 2
      }
    },
    mounted: async function () {
      await this.updateProfileList()
    },
    computed: {
      ...mapGetters('profile', [
        'getProfileList',
        'getProfileTypeList'
      ]),
      profileList: function () {
        return this.getProfileList.map(e => ({
          ...e,
          profileType: this.getProfileTypeList.find(t => t.id === e.typeId)
        }))
      }
    },
    methods: {
      ...mapMutations('profile', [
        'setCurrentStep'
      ]),
      ...mapActions('profile', [
        'updateProfileList',
        'editProfile',
        'removeProfile',
        'createProfile'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/ProfileList.vue